import React, { FC } from "react";
import Spin from "antd/lib/spin";

import { useErrorNotification, useSuccessNotification } from "./hooks";

import { SpinProps } from "antd/lib/spin";
import { APIRequestState } from "@skydio/redux_util/src";

interface Props extends SpinProps {
  request: APIRequestState;
  successMessage?: string;
}

const RequestStatus: FC<Props> = ({
  request: { active, success, error },
  successMessage = "",
  children,
  ...props
}) => {
  useErrorNotification(error);
  useSuccessNotification(success, successMessage);

  return (
    <Spin spinning={active} {...props}>
      {children}
    </Spin>
  );
};

export default RequestStatus;
